
define('ldsh!modules/form_editor/templates/editor_custom_gender', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="flex flex-column gap-8 mt24">\n  <div class="md__checkbox--wrapper">\n    <input\n      id="first-value-invalid"\n      type="checkbox"\n      class="md__checkbox--primary js-first"\n      ' +
((__t = ( firstOptionInvalid ? "checked": "" )) == null ? '' : __t) +
'\n    />\n    <label\n      for="first-value-invalid"\n      data-i18n="formEditor.dropDownFirstValueInvalid"\n    >Primer valor no válido</label>\n  </div>\n\n  <div class="md__checkbox--wrapper">\n    <input\n      id="other-value"\n      type="checkbox"\n      class="md__checkbox--primary js-other"\n      ' +
((__t = ( addOther ? "checked": "" )) == null ? '' : __t) +
'\n    />\n    <label\n      for="other-value"\n      data-i18n="formEditor.dropDownAddOther"\n    >Añadir Otros</label>\n  </div>\n</div>\n<h4 data-i18n="formEditor.elementsTitle">Elementos</h4>\n<div class="js-items"></div>\n';

}
return __p
};});

